import { isValidElement, type ReactNode } from 'react'

/** ReactNode から表示テキストだけを取り出す。子を持たないコンポーネントは空文字になる */
export const reactNodeToText = (node: ReactNode): string => {
  if (node === null || node === undefined || typeof node === 'boolean') return ''
  if (typeof node === 'string' || typeof node === 'number' || typeof node === 'bigint') return String(node)
  if (Array.isArray(node)) return node.map(reactNodeToText).join('')
  if (!isValidElement<{ children?: ReactNode }>(node)) return ''
  return reactNodeToText(node.props.children)
}
